import { Outlet, useLocation } from 'react-router-dom';
import { Favicon } from '@/components/ui';
import Filter from '../../filter/Filter';
import {
	Authorization,
	Adult,
	RestorePasswordPopup,
	StartVideochat,
	CreateVideoCallRoom,
	AfterAuth,
} from '../../popups';
import VideoChat from '../../videoChat/VideoChat';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
	getAdultState,
	getShowTariffsGuestPopup,
} from '@/stores/slices/popupSlice';

import MapFilter from '../../mapFilter/MapFilter';

import NewPassPopup from '../../popups/newPass/NewPass';
import { showFilter } from '@/stores/slices/showFilterSlice';
import { getAuthorizationStatus } from '@/stores/slices/popupSlice';
import { getCreateVideoRoomModalStatus } from '@/stores/slices/videoCallSlice';
import { getNewPassStatus } from '@/stores/slices/popupSlice';
import { getStartVideochatStatus } from '@/stores/slices/popupSlice';
import { getVideoCallModalStatus } from '@/stores/slices/videoCallSlice';
import { getMapStatus } from '@/stores/slices/popupSlice';
import { getAfterAuth } from '@/stores/slices/popupSlice';

import Header from '../../header/Header';
import Footer from '../../footer/Footer';
import useLadyService from '@/services/LadyService';
import SEOBlock from './SEOBlock';

import { Helmet } from 'react-helmet';
import {
	getBookingAmount,
	getPreviewsAmount,
	getUserTickets,
	getVideochatAmount,
} from '@/stores/slices/userSlice';
import showToast from '@/components/toast/Toast';
import TarrifsListPopup from '@/components/popups/TarrifsListPopup/TarrifsListPopup';

const Layout = ({ initialData }) => {
	const { userTypeAgency, userTypeIndi, t, lang } = useLadyService();
	const location = useLocation();

	const {
		adultPopupState,
		filterValue,
		authorizationValue,
		modalStatus,
		statusNewPass,
		videochatStatus,
		modalStatusCall,
		mapPopupStatus,
		afterAuthStatus,
		tariffsGuestPopup,
		userTickets,
		userPreviews,
		userOrders,
		videoChats,
	} = useSelector((state) => ({
		adultPopupState: getAdultState(state),
		filterValue: showFilter(state),
		authorizationValue: getAuthorizationStatus(state),
		modalStatus: getCreateVideoRoomModalStatus(state),
		statusNewPass: getNewPassStatus(state),
		videochatStatus: getStartVideochatStatus(state),
		modalStatusCall: getVideoCallModalStatus(state),
		mapPopupStatus: getMapStatus(state),
		afterAuthStatus: getAfterAuth(state),
		tariffsGuestPopup: getShowTariffsGuestPopup(state),
		userTickets: getUserTickets(state),
		userPreviews: getPreviewsAmount(state),
		userOrders: getBookingAmount(state),
		videoChats: getVideochatAmount(state),
	}));

	const pathname = location.pathname;

	useEffect(() => {
		if (afterAuthStatus) {
			if (userTickets > 0) {
				showToast({
					subMessage: t('newnotice'),
					message: t('support'),
					variant: 'info',
				});
			}

			if (userTypeIndi || userTypeAgency) {
				if (userOrders > 0) {
					showToast({
						type: 'booking',
						variant: 'booking',
					});
				}

				if (userPreviews > 0) {
					showToast({
						type: 'preview',
						variant: 'preview',
					});
				}

				if (videoChats > 0) {
					showToast({
						type: 'video',
						variant: 'video',
					});
				}
			}
		}
	}, [userTickets, userPreviews, userOrders, videoChats, afterAuthStatus]);

	const langs = ['cz', 'ru', 'en', 'de', 'sk'];

	return (
		<>
			<Favicon />
			{!pathname.includes('404') && !pathname.includes('lk') && (
				<Helmet>
					<link
						rel="canonical"
						href={window.location.href}
					/>

					<meta
						property="og:type"
						content="website"
					/>
					<meta
						property="og:url"
						content={window.location.href}
					/>
					<meta
						property="og:locale"
						content={lang === 'cz' ? 'cs' : lang}
					/>
					{langs
						.filter((i) => {
							switch (lang) {
								case 'cz': {
									return i !== 'cs';
								}
								default: {
									return i !== lang;
								}
							}
						})
						.map((i, idx) => (
							<meta
								key={idx + '_og.meta.alt.locale'}
								property="og:locale:alternate"
								content={i}
							/>
						))}
					<meta
						property="og:site_name"
						content="Lady4Love"
					/>
					<meta
						property="og:image"
						content="https://lady4love.com/static/media/benefits-bg-dark.8af83ecc9d0e63aa3eb3.webp"
					/>

					<link
						rel="alternate"
						hreflang="en"
						href={
							'https://lady4love.com' +
							pathname.replace(`/${lang}`, '/en')
						}
					/>
					<link
						rel="alternate"
						hreflang="ru"
						href={
							'https://lady4love.com' +
							pathname.replace(`/${lang}`, '/ru')
						}
					/>
					<link
						rel="alternate"
						hreflang="cs"
						href={
							'https://lady4love.com' +
							pathname.replace(`/${lang}`, '/cz')
						}
					/>
					<link
						rel="alternate"
						hreflang="de"
						href={
							'https://lady4love.com' +
							pathname.replace(`/${lang}`, '/de')
						}
					/>
					<link
						rel="alternate"
						hreflang="sk"
						href={
							'https://lady4love.com' +
							pathname.replace(`/${lang}`, '/sk')
						}
					/>
					<link
						rel="alternate"
						hreflang="x-default"
						href={
							'https://lady4love.com' +
							pathname.replace(`/${lang}`, '/en')
						}
					/>
				</Helmet>
			)}

			<Header />
			<Outlet />
			<SEOBlock />
			<Footer />

			{!!filterValue && <Filter />}
			{!!authorizationValue && <Authorization />}
			<RestorePasswordPopup />
			{!!statusNewPass && <NewPassPopup />}
			{!!modalStatus && <CreateVideoCallRoom />}
			{!!videochatStatus && <StartVideochat />}
			{!!modalStatusCall && <VideoChat />}
			{!!mapPopupStatus && (
				<MapFilter />
			)}
			{!!adultPopupState && <Adult />}
			{!!afterAuthStatus && <AfterAuth />}
			{!!tariffsGuestPopup && <TarrifsListPopup />}
		</>
	);
};

export default Layout;
